const merge = require('deepmerge');
const { Fragment } = wp.element;
const { applyFilters, doAction } = wp.hooks;
// Update faq items if toggle clicked, or between page loads (e.g. incase FAQ items have been reordered)
// @TODO can delete this as it's not needed?
export function updateFaqItems(props) {
	const {
		attributes: { faqPostId, faqGroupId, faq_group_toggle },
		setAttributes,
	} = props;

	// update the FAQs order if changed on the CPT. note: this only updates the faqItems attribute if the fetched data is different from the current attribute, so we don't need to check manually.

	// @TODO should ideally check and sanitize faqPostId/faqGroupId
	let faqId,
		url = null;
	if (faq_group_toggle) {
		faqId = JSON.parse(faqGroupId).value;
		if (faqId === undefined) {
			setAttributes({ faqItems: '' });
			return;
		}
		url = `flexible-faqs/v1/get-group-faqs/${faqId}`;
	} else {
		faqId = JSON.parse(faqPostId).value;
		if (faqId === undefined) {
			setAttributes({ faqItems: '' });
			return;
		}
		url = `flexible-faqs/v1/get-faqs/${faqId}`;
	}

	wp.apiFetch({ path: url, method: 'GET' }).then(
		(data) => {
			const newFaqItems = [...data];
			// SetAttributes will only overwrite FAQs if different, so no manual check required.
			setAttributes({ faqItems: JSON.stringify(newFaqItems) });
			return data;
		},
		(err) => {
			return err;
		}
	);
}

// Set FAQ theme style attributes.
export function setStyle(style, newVal, props) {
	const { setAttributes, attributes } = props;
	const tmpAttr = {};

	tmpAttr[style] = newVal;
	tmpAttr.faqThemeCustomizedStatus = true;

	// Hook Pro Feature at this moment of time if any.
	// const tmpAttrFiltered = applyFilters(
	// 	'recalc-first-faq-height',
	// 	props,
	// 	tmpAttr
	// );
	//console.log('tmpAttrFiltered', tmpAttrFiltered);
	//console.log('[B] tmpAttr', tmpAttr);
	doAction('recalc-first-faq-height', props, tmpAttr);
	//console.log('[A] tmpAttr', tmpAttr);

	setAttributes(tmpAttr);
	//setAttributes(tmpAttrFiltered);
}

export function updateCustomThemes(customThemeData, faqStyle) {
	// @todo add permission check?
	const url = `flexible-faqs/v1/${faqStyle}`;

	return wp
		.apiFetch({
			path: url,
			method: 'POST',
			body: customThemeData,
		})
		.then((custom_themes) => custom_themes)
		.catch((error) => error);
}

// @TODO change this to getCustomThemes?
// fetch custom themes from endpoint
export function getThemes(faqStyle) {
	const url = `flexible-faqs/v1/${faqStyle}`;
	//console.log('<<< EP URL: ', url);

	return wp
		.apiFetch({
			path: url,
			method: 'GET',
		})
		.then((custom_themes) => custom_themes)
		.catch((error) => error);
}

export const log = (output, debug = true) => {
	if (debug) {
		if (Array.isArray(output)) {
			//console.log(...output);
		} else {
			//console.log(output);
		}
	}
};

// @todo allow an array of state properties and an array of props values as 2nd and 3rd parameters to skip certain values from being displayed (e,g, if the output is too long).
export const Debug = (props) => {
	//console.log('DEBUG:', props.state, props.props);

	if (props.off) return null;

	return (
		<Fragment>
			<h4 className="faq-debug-heading">State</h4>
			<table className="faq-debug">
				{Object.entries(props.state).map(([key, value]) => {
					if (typeof value === 'function') {
						value = '[function]';
					}
					return (
						<tr>
							<td className="faq-debug-key">
								{JSON.stringify(key, null, '\t')}
							</td>
							<td className="faq-debug-val">
								{JSON.stringify(value, null, '\t')}
							</td>
						</tr>
					);
				})}
			</table>
			<h4 className="faq-debug-heading">Props</h4>
			<table className="faq-debug">
				{Object.entries(props.props).map(([key, value]) => {
					if (typeof value === 'function') {
						value = '[function]';
					}
					return (
						<tr>
							<td className="faq-debug-key">
								{JSON.stringify(key, null, '\t')}
							</td>
							<td className="faq-debug-val">
								{JSON.stringify(value, null, '\t')}
							</td>
						</tr>
					);
				})}
			</table>
		</Fragment>
	);
};
